
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
           .directive('npAlert', npAlert);

    function npAlert() {
        return {
            restrict: 'E',
            templateUrl: '/app/shared/alert/alert.html',
            scope: {
                alerts: '=',
            },
            controller: ['$scope', controller],
            controllerAs: 'vm'
        }

        function controller($scope) {
            var vm = this;
            vm.alerts = $scope.alerts;

            vm.closeAlert = closeAlert;

            function closeAlert(index) {
                vm.alerts.splice(0, vm.alerts.length);
            }
        }
    }
})();